import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export interface ProductNameProps {
  children: React.ReactNode;
  className?: string;
}

export const ProductName: React.FC<React.PropsWithChildren<ProductNameProps>> = ({ children, className }) => {
  return (
    <Wrapper className={className}>
      <Text className={Typography.BODY_15_REGULAR}>{children}</Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 9px 0;
  width: 100%;
  position: relative;
`;

const Text = styled.h1`
  line-height: 150%;
  color: ${vars.color.textStrong};

  svg,
  img {
    margin: 0 6px 0 0;
    position: relative;
    top: 3px;
  }
`;
